import { LeadingActions, SwipeableList, SwipeableListItem, SwipeAction, TrailingActions, Type as ListType } from 'react-swipeable-list';
import React, { useRef } from 'react';

const SwipeableItem = ({ children, actions, fullSwipe }) => {
  const listItemRef = useRef(null);
  const listItem = (listItemRef.current || {}).listElement || {};

  const handleClick = (n, idx) => {
    if (n.onClick) {
      n.onClick({ action: n, listItem, index: idx });
    }
  };

  const leadingActions = () => (
    <LeadingActions>
      {actions
        .filter((n) => n.type === 'leading')
        .map((n, idx) => (
          <SwipeAction key={idx} onClick={() => handleClick(n, idx)} destructive={n.destructive || false} Tag={'div'} className={n.color}>
            {n.label}
          </SwipeAction>
        ))}
    </LeadingActions>
  );

  const trailingActions = () => (
    <TrailingActions fullSwipe={true}>
      {actions
        .filter((n) => n.type === 'trailing')
        .map((n, idx) => (
          <SwipeAction key={idx} onClick={() => handleClick(n, idx)} destructive={n.destructive || false} Tag={'div'} className={n.color} fullSwipe={true}>
            {n.label}
          </SwipeAction>
        ))}
    </TrailingActions>
  );

  return (
    <SwipeableList fullSwipe={fullSwipe || false} type={ListType.IOS}>
      <SwipeableListItem leadingActions={leadingActions()} trailingActions={trailingActions()} ref={listItemRef}>
        {children}
      </SwipeableListItem>
    </SwipeableList>
  );
};

export default SwipeableItem;
